module.exports = __webpack_public_path__ + "static/media/Portrait-10275.b790ac7a.jpg";